import { useQuery } from "react-query";

import {
  LedgerAccountRead,
  LedgerAccountReadList,
} from "types/api/deal/accounting/ledger_account";
import { LookupItem } from "types/api/deal/form";
import { coreService } from "utils/axios";

export const getLedgerAccountQueryKey = (ledger_account_id: string) => [
  "ledger_account",
  ledger_account_id,
];

export const useLedgerAccountQuery = (ledger_account_id: string) => {
  const query = useQuery<LedgerAccountRead>({
    queryKey: getLedgerAccountQueryKey(ledger_account_id),
    queryFn: () =>
      coreService
        .get(`/ledger_account/${ledger_account_id}`)
        .then((response) => {
          return response.data;
        }),
  });

  return query;
};

export const getLedgerAccountsQueryKey = (queryParams?: URLSearchParams) =>
  queryParams
    ? ["ledger_account_table", queryParams.toString()]
    : ["ledger_account_table"];

export const useLedgerAccountsQuery = (queryParams: URLSearchParams) => {
  const query = useQuery<LedgerAccountReadList>({
    queryKey: getLedgerAccountsQueryKey(queryParams),
    queryFn: () =>
      coreService
        .get(`/ledger_account`, { params: queryParams })
        .then((response) => {
          return response.data;
        }),
  });

  return query;
};

export const getLedgerAccountsLookupQueryKey = (
  queryParams?: URLSearchParams
) =>
  queryParams
    ? ["ledger_account_lookup", queryParams.toString()]
    : ["ledger_account_lookup"];

export const useLedgerAccountsLookupQuery = (queryParams?: URLSearchParams) => {
  const query = useQuery<LookupItem[]>({
    queryKey: getLedgerAccountsLookupQueryKey(queryParams),
    queryFn: () =>
      coreService
        .get(`/ledger_account/lookup`, { params: queryParams })
        .then((response) => {
          return response.data;
        }),
  });

  return query;
};
